import { apiClient, ApiError } from './apiClient';

export interface SupportTicket {
    id: string;
    userId: string;
    email: string;
    message: any;
    messageType: string;
    isResolved: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface CreateSupportTicketData {
    userId: string;
    email: string;
    message: any;
    messageType: 'feature_request' | 'bug_report';
}

export const supportApi = {
    async createTicket(data: CreateSupportTicketData): Promise<{ message: string }> {
        return apiClient.post('/api/support', data);
    },

    // Note: GET methods return the full API response { success: boolean, data: T }
    // You need to access response.data to get the actual ticket(s)
    async getTicket(ticketId: string): Promise<any> {
        return apiClient.get(`/api/support/${ticketId}`);
    },

    async getAllTickets(): Promise<any> {
        return apiClient.get('/api/support');
    },

    async getUnresolvedTickets(): Promise<any> {
        return apiClient.get('/api/support/unresolved/all');
    },

    async resolveTicket(ticketId: string): Promise<{ message: string }> {
        const response = await fetch(`${apiClient['baseUrl']}/api/support/${ticketId}/resolve`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('sessionToken')}`
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Failed to resolve ticket' }));
            throw new ApiError(response.status, errorData.error || 'Failed to resolve ticket');
        }

        const data = await response.json();
        return data.data;
    },

    async deleteTicket(ticketId: string): Promise<void> {
        return apiClient.delete(`/api/support/${ticketId}`);
    }
};

